import styled, { css } from 'vue3-styled-components';

export const CompanyGetDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    max-width: 1200px;
    width: 100%;
`;

export const CompanyGetTitleArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-weight: bold;
    font-size: 28px;
    margin-bottom: 35px;
    gap: 12px;
    color: #1f2937;
`;

export const TitleText = styled.span`
    color: #1f2937;
    font-weight: 700;
`;

export const SearchAndStatsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 24px;
    gap: 20px;
`;

export const CompanyGetSearchArea = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
`;

export const CompanySelect = styled.select`
    background: #ffffff;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    color: #374151;
    cursor: pointer;
    min-width: 120px;
    transition: all 0.2s ease;

    &:hover {
        border-color: #0f4c5c;
        box-shadow: 0 2px 8px rgba(251, 139, 36, 0.1);
    }

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(251, 139, 36, 0.1);
    }

    option {
        background: white;
        color: #374151;
        padding: 8px;
    }
`;

export const CompanyGetSearchInputTxt = styled.input`
    background: #ffffff;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    color: #374151;
    min-width: 200px;
    transition: all 0.2s ease;

    &::placeholder {
        color: #9ca3af;
    }

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(251, 139, 36, 0.1);
    }
`;

export const CompanyGetSearchBtn = styled.button`
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 7px 10px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

// * 통계 박스
export const StatsBox = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
`;

export const StatItem = styled.div`
    background: linear-gradient(135deg, #fb8b24 0%, #ea580c 100%);
    border-radius: 16px;
    padding: 16px 24px;
    box-shadow: 0 4px 12px rgba(251, 139, 36, 0.2);
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: white;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(251, 139, 36, 0.3);
    }
`;

export const StatLabel = styled.span`
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    font-weight: 500;
    margin-right: 8px;
`;

export const StatValue = styled.span`
    color: white;
    font-size: 18px;
    font-weight: 700;
`;

// * 테이블
export const CompanyGetTable = styled.table`
    width: 100%;
    table-layout: fixed; // 테이블 레이아웃 고정
    border-collapse: separate;
    border-spacing: 0;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e7eb;
    
    // 컬럼 너비 설정
    th:nth-child(1), td:nth-child(1) { width: 5%; } // 즐겨찾기
    th:nth-child(2), td:nth-child(2) { width: 20%; } // 거래처명
    th:nth-child(3), td:nth-child(3) { width: 10%; } // 거래처번호
    th:nth-child(4), td:nth-child(4) { width: 25%; } // 주소
    th:nth-child(5), td:nth-child(5) { width: 15%; } // 전화번호
    th:nth-child(6), td:nth-child(6) { width: 15%; }  // 이메일
`;

export const CompanyGetTableThead = styled.thead`
    background: linear-gradient(135deg, #fb8b24, #ea580c);
    color: white;
`;

export const CompanyGetTableTbody = styled.tbody`
    max-height: 400px;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f5f9;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #fb8b24;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #ea580c;
    }
`;

export const CompanyGetTableTr = styled.tr`
    th {
        padding: 16px 12px;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        word-wrap: break-word;
        word-break: break-word;
        white-space: normal;
        vertical-align: middle;
    }
    
    td {
        padding: 16px 12px;
        font-size: 14px;
        text-align: center;
        border-bottom: 1px solid #f1f5f9;
        color: #374151;
        word-wrap: break-word;
        word-break: break-word;
        white-space: normal;
        vertical-align: middle;
        line-height: 1.4;
    }
    
    &.company_tr {
        cursor: pointer;
        
        &:hover {
            background: #fef3c7;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(251, 139, 36, 0.1);
        }
        
        &:last-child td {
            border-bottom: none;
        }
    }
`;

export const FavoriteCell = styled.td`
    width: 80px;
    text-align: center;
`;

export const FavoriteIcon = styled.span`
    font-size: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: ${props => props.favorite ? '#fbbf24' : '#d1d5db'};
    
    &:hover {
        transform: scale(1.2);
        color: #fbbf24;
    }
`;

// * 페이지네이션
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 0;
    margin-top: 16px;
`;

export const Pagination = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background: white;
    padding: 8px;
    border-radius: 12px;
`;

export const PaginationButton = styled.button`
    padding: 6px 10px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #6b7280;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
        transform: translateY(-1px);
    }
    
    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        transform: none;
    }
`;

const paginationNumberProps = css`
    ${props => props.active && css`
        background: #fb8b24;
        color: white;
        border-color: #fb8b24;
        transform: scale(1.1);
    `}
`;

export const PaginationNumber = styled.button`
    min-width: 40px;
    height: 40px;
    padding: 0 12px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #6b7280;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s ease;
    white-space: nowrap;
    ${paginationNumberProps}
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
        transform: translateY(-1px);
    }
`;

// 로딩 스피너 컴포넌트
export const LoadingOverlay = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 60px 20px;
    background: #ffffff;
    border-radius: 8px;
    position: relative;
`;

export const LoadingSpinner = styled.div`
    width: 48px;
    height: 48px;
    border: 4px solid #e5e7eb;
    border-top-color: #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 20px;
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

export const LoadingText = styled.div`
    font-size: 15px;
    font-weight: 400;
    color: #374151;
    letter-spacing: 0;
    line-height: 1.5;
`;